import { useEffect, useState } from "react";
import { ADD_ICON, CONSULTATION_ICONS } from "../../cufront-assets/icons/Icons";
import "../css/ConsultationMain.css";
import ConsultationFields from "./ConsultationFields";
import ConsultationRightBar from "./ConsultationRightBar";
import AddInvestigation from "../component/AddInvestigation";
import MobileModal from "../../new_appointment/appoinment/components/MobileModal";
import { MobileModalBody } from "../../new_appointment/appoinment/components/MobileModalBody";
import { useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../_helper/constant/Permission";
import {
  useItemsFilter,
  useItemsFilterNew,
} from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { previousVisitsAtom, tagTypesAtom } from "../constants/_constant";
import AddHistory from "../component/AddHistory";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import CuModal from "../../common_component/component/CuModal";
import PrintPreview from "../component/PrintPreview";
import { toast } from "react-toastify";
import Visit from "../component/Visit";
import { MdOutlineWorkHistory } from "react-icons/md";
import {
  convertToCustomFormat,
  deepCopy,
  formatDate,
} from "../../_helper/utils/utils";
import { useMediaQuery } from "react-responsive";
import MobileConsultation from "../../mobile_consultation/pages/MobileConsultation";
import Popup from "../../common_component/component/Popup";
import ImagePreview from "../../common_component/component/ImagePreview";
import CertificateView from "../component/CertificateView";

const initialMedState = [
  {
    id: null,
    medicineName: "",
    recentlyUsedCount: 0,
    genericName: {
      name: "",
    },
    medicineType: {
      name: "",
      label: "",
    },
    dosage: {
      label: "",
      name: "",
    },
    unit: {
      label: "",
      name: "",
    },
    when: {
      label: "",
      name: "",
    },
    frequency: {
      label: "",
      name: "",
    },
    duration: "",
    notes: {
      name: "",
    },
    timing: {
      name: "",
    },
    category: {
      name: "",
    },
  },
];

export const manageSeq = (vitalsData = []) => {
  const sequence = [
    "SPO2",
    "BP",
    "PULSE",
    "WEIGHT",
    "HEIGHT",
    "TEMPRATURE",
    "RESPIRARORY RATE",
  ];

  for (let i of vitalsData) {
    if (!sequence.includes(i?.type?.label.trim().toUpperCase())) {
      sequence.push(i?.type?.label.trim().toUpperCase());
    }
  }

  const temp = [];

  for (let i of sequence) {
    for (let j of vitalsData) {
      if (i.trim().toUpperCase() === j?.type?.label.trim().toUpperCase()) {
        temp.push(j);
      }
    }
  }

  return temp;
};

const ConsultationMain = () => {
  const [openInvestigation, setOpenInvestigation] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openVisit, setOpenVisit] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extracting individual query parameters
  const slotId = queryParams.get("slotId");
  const userId = queryParams.get("userId");
  const billId = queryParams.get("bill_id");
  const consultationId = queryParams.get("consultationId");
  const option = queryParams.get("option");
  const [medicineData, setMedicineData] = useState(deepCopy(initialMedState));
  const [customfields, setCustomfields] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [patientHistory, setPatientHistory] = useState([]);
  const [addictions, setAddictions] = useState([]);
  const [advices, setAdvices] = useState(null);
  const [nextVisit, setNextVisit] = useState("");
  const [vitals, setVitals] = useState([]);
  const [billingServices, setBillingServices] = useState([]);
  const { role_id } = useCurrentRole();
  const [clinic] = useAtom(clinicAtom);
  const [previousVisits, setPreviousVisits] = useAtom(previousVisitsAtom);
  const [isPrintPreview, setIsPrintPreview] = useState(false);
  const [printData, setPrintData] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [mainImage, setMainImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [observation, setObservation] = useState("");
  const [isCertificate, setIsCertificate] = useState(false);
  const [{ prescription_setup, header_footer_setup }] =
    useAtom(doctorSettingAtom);
  const [tagType] = useAtom(tagTypesAtom);

  const navigate = useNavigate();
  const sm = useMediaQuery({ query: "(max-width:635px)" });

  const resetAllConsultationStates = () => {
    setMedicineData(deepCopy(initialMedState));
    setCustomfields([]);
    setAllergies([]);
    setPatientHistory([]);
    setAddictions([]);
    setAdvices(null);
    setNextVisit("");
    setVitals([]);
  };

  const { data: slotData } = useItemsFilter(
    ApiEndPoint.BOOKING,
    `?action=getSlots&clinic_id=${clinic?.id}&backend=True&id=${slotId}`,
    slotId && clinic?.id ? true : false
  );

  const files =
    slotData && slotData[0]?.related_records?.uploadedFile
      ? slotData[0]?.related_records?.uploadedFile?.flat()
      : [];

  const { data: consultationData, isLoading: consultationLoading } =
    useItemsFilter(
      ApiEndPoint.QP_CM_CONSULTATION_DATA,
      `?action=getConsultationData&frontend=True&clinic_id=${clinic?.id}&id=${consultationId}`,
      clinic?.id && consultationId ? true : false
    );

  const { data: userDetails, isLoading: userLoading } = useItemsFilter(
    ApiEndPoint.USERS,
    `?action=getUserDetails&backend=True&clinic_id=${clinic?.id}&id=${userId}`,
    clinic?.id && userId ? true : false
  );

  const { data: previousConsultations } = useItemsFilter(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    `?action=getConsultationData&clinic_id=${clinic?.id}&backend=True&patients_id=${userId}`,
    clinic?.id && userId ? true : false
  );

  //("consultationData", consultationData);

  useEffect(() => {
    if (previousConsultations) {
      setPreviousVisits(previousConsultations);
    }
  }, [previousConsultations]);

  useEffect(() => {
    if (userDetails?.length > 0) {
      setAllergies(userDetails[0]?.allergy);
      setPatientHistory(userDetails[0]?.medical_history);
      setAddictions(userDetails[0].addictions);
    }
  }, [userDetails]);

  useEffect(() => {
    if (consultationData) {
      setMedicineData(
        consultationData?.medicine_data?.length > 0
          ? consultationData?.medicine_data
          : deepCopy(initialMedState)
      );
      setVitals(manageSeq(consultationData?.qp_cm_vitals));
      setAdvices(consultationData?.qp_cm_advices);
      setCustomfields(consultationData?.qp_cm_consultation_tags);
      setObservation(consultationData?.observation);
      setNextVisit(consultationData?.next_visit_date);
    }
  }, [consultationData]);

  // //("custom fields--------", customfields);

  let name, profile_image, phone;
  if (userDetails?.length > 0) {
    name = userDetails[0]?.full_name;
    // dob = userDetails[0]?.dob;
    // gender = userDetails[0]?.gender;
    phone = userDetails[0]?.phone;
    // email = userDetails[0]?.email;
    profile_image = userDetails[0]?.profile_image;
  }

  const updateConsultation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  const endConsultation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  const printConsultation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  const readingConsultation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  const shareConsultation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  const types = {
    save: updateConsultation,
    end: endConsultation,
    print: printConsultation,
    reading: readingConsultation,
    share: shareConsultation,
  };

  const getInvoiceData = (response) => {
    return response.data;
  };

  const getInvoiceNo = (response) => {
    return response.invoice_number;
  };

  const { data: invoiceNo } = useItemsFilterNew(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getNumberSequenceByname&clinic_id=${clinic?.id}&backend=True&transaction_type=OPD INVOICE&bill_type=OPD`,
    clinic?.id && billId === "null" ? true : false,
    getInvoiceNo
  );

  const viewInvoiceQuery = `?action=getBillingCreditInvoice&frontend=True&clinic_id=${clinic?.id}&id=${billId}`;
  const { data: editData } = useItemsFilterNew(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    viewInvoiceQuery,
    clinic?.id && billId !== "null" ? true : false,
    getInvoiceData
  );

  const sendNotificationMutation = useCreateItem(ApiEndPoint.CLINIC);
  const postBillingMutation = useCreateItem(ApiEndPoint.BILLING_CREDIT_INVOICE);
  const updateBillingMutation = useSecureUpdateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );

  const getInvoiceLines = () => {
    const invoiceTotal = billingServices?.reduce(
      (acc, line) => acc + Number(line?.total),
      0
    );
    return invoiceTotal;
  };

  function removeStepKeyFromArray(arr) {
    return arr.map((obj) => {
      // Create a shallow copy of each object
      const newObj = { ...obj };

      // Delete the "step" and "id" keys if they exist
      if ("step" in newObj) {
        delete newObj.step;
      }
      if ("id" in newObj) {
        delete newObj.id;
      }

      return newObj;
    });
  }

  const onBillingSaveSuccess = (billId) => {
    // Create a new URLSearchParams object from the current query params
    const searchParams = new URLSearchParams(location.search);

    // Set or update the 'bill_id' parameter
    searchParams.set("bill_id", billId);

    // Use navigate to update the URL with new query params without reloading
    navigate(
      {
        pathname: location.pathname, // keep the current path
        search: `?${searchParams.toString()}`, // update the query params
      },
      { replace: true }
    ); // `replace: true` to prevent adding a new entry in history
  };

  useEffect(() => {
    if (editData) {
      const modifiedLines =
        editData?.invoice_lines?.map((line) => {
          return { ...line, line_service: line?.line_service?.id };
        }) || [];
      setBillingServices(modifiedLines);
    }
  }, [editData]);

  const handleSaveInvoice = () => {
    if (billingServices?.length > 0) {
      const invoiceTotal = getInvoiceLines();

      const invoiceDate = editData?.invoice_date
        ? moment(editData?.invoice_date).toDate()
        : moment().toDate();

      const action = editData?.id
        ? "patchBillingCreditInvoice"
        : "postBillingCreditInvoice";

      if (editData?.id) {
        const receivedAmt = editData?.billing_credit_payments?.reduce(
          (acc, payment) => acc + Number(payment?.received_payment),
          0
        );
        if (Number(receivedAmt) === Number(editData?.invoice_total)) {
          toast.error(
            "This is paid invoice so you cannot add more service to it"
          );
          return;
        }
        const payload = {
          id: editData?.id,
          action,
          backend: "True",
          clinic_id: clinic?.id,
          invoice_lines: removeStepKeyFromArray(billingServices),
          invoice_total: invoiceTotal,
          feature_name: "invoice",
        };
        updateBillingMutation.mutate(
          { data: payload },
          { onSuccess: () => {}, onError: () => {} }
        );
      } else {
        const payload = {
          action,
          backend: "True",
          clinic_id: clinic?.id,
          patient_details: Number(userId),
          admission_details: {
            admission_date: "",
            admission_time: "",
            discharge_date: "",
            discharge_time: "",
            IPD_No: "",
            ipd_id: null,
            injury_no: "",
          },
          discount: 0,
          discount_type: "percentage",
          invoice_no: invoiceNo,
          slot_id: Number(slotId),
          invoice_lines: removeStepKeyFromArray(billingServices),
          status: "draft",
          bill_type: "OPD",
          invoice_total: invoiceTotal,
          invoice_date: invoiceDate,
          institution: false,
        };
        postBillingMutation.mutate(payload, {
          onSuccess: (data) => {
            //(data);
            onBillingSaveSuccess(data?.data?.id);
          },
          onError: () => {},
        });
      }
    }
  };

  function removeIdFromNewType(customfields) {
    return customfields?.map((field) => {
      if (field.type === "new") {
        const { id, ...rest } = field; // Destructure to remove 'id'
        return rest; // Return the object without 'id'
      }
      return field; // Return the object as is if 'type' is not 'new'
    });
  }

  const handleSaveConsultation = (
    type,
    click = "save",
    notificationTypes,
    sendDetails,
    closeNotification
  ) => {
    const medicine_data = removeIdFromNewType(medicineData);
    const consultation_payload = {
      id: Number(consultationId),
      action: "patchConsultationData",
      qp_cm_vitals: vitals?.map((vital) => {
        return {
          ...vital,
          type: vital?.type?.id,
        };
      }),
      status: type,
      next_visit_date:
        moment(nextVisit, "DD-MM-YYYY").format("YYYY-MM-DD") === "Invalid date"
          ? null
          : moment(nextVisit, "DD-MM-YYYY").format("YYYY-MM-DD"),
      clinic_id: clinic?.id,
      doctor_user: role_id,
      qp_cm_advices: advices,
      personal_details: {
        id: Number(userId),
        allergy: allergies,
        medical_history: patientHistory,
        addictions: addictions,
      },
      slot_id: Number(slotId),
      medicine_data: medicine_data
        ?.filter((med) => med?.id)
        ?.map((ele) => {
          if (typeof ele?.id === "string" && ele?.id?.includes("new")) {
            return { ...ele, id: null };
          } else {
            return ele;
          }
        }),
      qp_cm_consultation_tags: removeIdFromNewType(customfields),
      observation: observation,
      frontend: "True",
    };

    types[click].mutate(
      { id: null, data: consultation_payload },
      {
        onSuccess: (data) => {
          handleSaveInvoice();
          if (type === "published") {
            navigate("/new/appointment/?all_clinic=false&view=day&session=All");
            resetAllConsultationStates();
            // handleSaveInvoice();
            localStorage.removeItem("ongoing_consultations");
          } else {
            if (click === "print") {
              handelPrint(data);
            }
            if (click === "share") {
              sendNotification(
                notificationTypes,
                data,
                sendDetails,
                closeNotification
              );
            }
            toast.success("Consultation has been saved successfully");
          }
        },
        onError: () => {
          toast.error("Something went wrong please try again");
        },
      }
    );
  };

  const removeId = (data) => {
    const modifiedData = data?.map((ele) => {
      const { id, ...rest } = ele;
      return rest;
    });
    return modifiedData;
  };

  const handlePreviousClick = () => {
    if (
      consultationData?.status === "draft" &&
      previousConsultations?.length > 0
    ) {
      if (previousConsultations[0]?.medicine_data?.length > 0) {
        setMedicineData(previousConsultations[0]?.medicine_data);
      }
      setVitals(manageSeq(removeId(previousConsultations[0]?.qp_cm_vitals)));
      setAdvices(previousConsultations[0]?.qp_cm_advices);
      setCustomfields(previousConsultations[0]?.qp_cm_consultation_tags);
      setObservation(previousConsultations[0]?.observation);
    }
  };

  const handelPrint = (data) => {
    setPrintData(data);
    setIsPrintPreview(true);
  };

  const closeModal = () => {
    setOpenInvestigation(false);
  };

  const closeModalAddHistory = () => setOpenHistory(false);

  const handleShowRecord = () => {
    if (files && files.length > 0) {
      setShowPreview(true);
    } else {
      toast.error("No related records to show");
    }
  };

  const sendNotification = (
    notificationTypes,
    data,
    sendDetails,
    closeNotification
  ) => {
    const payload = {
      action: "postSharedMedicalRecord",
      clinic_id: clinic?.id,
      backend: "True",
      content: {
        data: data,
        userDetails: userDetails,
        allergies: allergies,
        patientHistory: patientHistory,
        settings: prescription_setup,
        header_footer_setup: header_footer_setup,
        tagData: tagType,
      },
      type: "prescription",
      phone: sendDetails.phone || phone,
      whatsapp_phone: sendDetails.whatsapp_phone,
      doctor_user_id: role_id,
      patient_name: name,
      patient_id: userId,
      is_sms: notificationTypes?.isSMS,
      is_whatsapp: notificationTypes?.isWhatsapp,
      is_email: notificationTypes?.isEmail,
    };

    //("Send Precription", payload);
    sendNotificationMutation.mutate(payload, {
      onSuccess: () => {
        toast.success("The prescription has been shared successfully");
        closeNotification();
      },
      onError: (err) => {
        toast.error(err.response.data.message);
      },
    });
  };

  const viewCertificate = () => {
    setIsCertificate(true);
  };

  if (consultationLoading || userLoading) {
    return <CuScreenLoader />;
  }

  // //("Mobile billing", billingServices);

  return (
    <div className="cu-consultation-container w-full pb-6">
      {sm && option === "ongoingconsultation" && (
        <MobileConsultation
          full_name={name}
          profile_image={profile_image}
          vitals={vitals}
          setVitals={setVitals}
          customfields={customfields}
          setCustomfields={setCustomfields}
          allergies={allergies}
          setAllergies={setAllergies}
          patientHistory={patientHistory}
          setPatientHistory={setPatientHistory}
          addictions={addictions}
          setAddictions={setAddictions}
          advices={advices}
          setAdvices={setAdvices}
          nextVisit={nextVisit}
          setNextVisit={setNextVisit}
          medicineData={medicineData}
          setMedicineData={setMedicineData}
          handleSaveConsultation={handleSaveConsultation}
          saveLoading={updateConsultation.isLoading}
          endLoading={endConsultation.isLoading}
          setObservation={setObservation}
          observation={observation}
          billingServices={billingServices}
          setBillingServices={setBillingServices}
          setIsPrintPreview={setIsPrintPreview}
          sendNotification={sendNotification}
          isSendNotificationLoading={sendNotificationMutation.isLoading}
        />
      )}
      {!sm && (
        <div className="flex gap-[6px]">
          <div className="flex flex-col flex-1 relative">
            <div className="cu-consultation-add-investigation-bar">
              {consultationData?.previous_follow_up_data?.date_created && (
                <div className="left-align-previous-follow-date">
                  <h6 className="text-md font-light text-gray-600">
                    Previous Consultation Date:
                    {` ${formatDate(
                      consultationData?.previous_follow_up_data?.date_created
                    )}`}
                  </h6>
                </div>
              )}
              {/* <button className="cu-consultation-add-investigation-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-add-investigation-btn-icon"
                  />
                </span>
                <span onClick={() => setOpenHistory(!openHistory)}>
                  Add History
                </span>
              </button> */}
              <button className="cu-consultation-add-investigation-btn">
                <span>
                  <img
                    src={ADD_ICON}
                    alt="add"
                    className="cu-consultation-add-investigation-btn-icon"
                  />
                </span>
                <span onClick={() => setOpenInvestigation(!openInvestigation)}>
                  Add Investigations
                </span>
              </button>
              <button
                className="cu-consultation-add-investigation-btn"
                onClick={handleShowRecord}
              >
                <span>Show Related Records</span>
              </button>
              <Popup
                trigger={
                  <button
                    className="cu-consultation-prev-btn"
                    onClick={handlePreviousClick}
                  >
                    <img
                      src={CONSULTATION_ICONS.PREV}
                      className="cu-consultation-prev-btn-icon"
                    />
                  </button>
                }
                content={"Previous Consultation"}
                position="top-right"
              />
              <Popup
                trigger={
                  <button
                    className="cu-consultation-prev-btn"
                    onClick={() => setOpenVisit(true)}
                  >
                    <MdOutlineWorkHistory size={25} color="gray" />
                  </button>
                }
                content={"Previous Visits"}
                position="top-right"
              />
            </div>
            <div className="cu-consultation-main">
              <ConsultationFields
                medicineData={medicineData}
                setMedicineData={setMedicineData}
                userId={userId}
                slotId={slotId}
                consultationId={consultationId}
                customfields={customfields}
                setCustomfields={setCustomfields}
                allergies={allergies}
                setAllergies={setAllergies}
                patientHistory={patientHistory}
                setPatientHistory={setPatientHistory}
                addictions={addictions}
                setAddictions={setAddictions}
                advices={advices}
                setAdvices={setAdvices}
                nextVisit={nextVisit}
                setNextVisit={setNextVisit}
                vitals={vitals}
                setVitals={setVitals}
                billingServices={billingServices}
                setBillingServices={setBillingServices}
                previousVisits={previousVisits}
                handleSaveConsultation={handleSaveConsultation}
                readingLoading={readingConsultation.isLoading}
                setObservation={setObservation}
                observation={observation}
              />

              <ConsultationRightBar
                handleSaveConsultation={handleSaveConsultation}
                saveLoading={updateConsultation.isLoading}
                endLoading={endConsultation.isLoading}
                printLoading={printConsultation.isLoading}
                phone={phone}
                sendNotification={handleSaveConsultation}
                isLoading={
                  shareConsultation.isLoading ||
                  sendNotificationMutation.isLoading
                }
                viewCertificate={viewCertificate}
              />
            </div>
          </div>
        </div>
      )}

      {showPreview && (
        <ImagePreview
          uploadedFile={files}
          mainImage={mainImage}
          setMainImage={setMainImage}
          setShowPreview={setShowPreview}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
        />
      )}

      {(consultationLoading || userLoading) && <CuScreenLoader />}
      {openInvestigation && (
        <MobileModal
          modalClassName={"modal-container-top-right-second"}
          isOpen={openInvestigation}
          closeModal={closeModal}
        >
          <MobileModalBody>
            <AddInvestigation
              closeModal={closeModal}
              labTestData={consultationData}
            />
          </MobileModalBody>
        </MobileModal>
      )}

      {openHistory && (
        <MobileModal
          modalClassName={"modal-container-top-right-second"}
          isOpen={openHistory}
          closeModal={closeModalAddHistory}
        >
          <MobileModalBody>{openHistory && <AddHistory />}</MobileModalBody>
        </MobileModal>
      )}

      {openVisit && (
        <MobileModal
          modalClassName={"modal-container-top-right-second"}
          isOpen={openVisit}
          closeModal={() => setOpenVisit(false)}
        >
          <MobileModalBody>
            {openVisit && (
              <Visit
                previousVisits={previousVisits}
                allergies={allergies}
                advices={advices}
                patientHistory={patientHistory}
                userDetails={userDetails}
              />
            )}
          </MobileModalBody>
        </MobileModal>
      )}
      {isPrintPreview && (
        <CuModal closeModal={() => setIsPrintPreview(false)}>
          <PrintPreview
            data={printData}
            closeModal={() => setIsPrintPreview(false)}
            userDetails={userDetails}
            allergies={allergies}
            addictions={addictions}
            patientHistory={patientHistory}
          />
        </CuModal>
      )}
      {isCertificate && (
        <CertificateView
          userDetails={userDetails}
          closeCertificate={() => setIsCertificate(false)}
        />
      )}
    </div>
  );
};

export default ConsultationMain;
